import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RendererComponent } from "../../renderer/renderer.component";
import { PageResolverService } from "../../rest/resolvers/page-resolver.service";

const routes: Routes = [
    {
        path: "",
        component: RendererComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
            page: PageResolverService,
        },
        children: [
            {
                path: ":slug",

                component: RendererComponent,
            },
            {
                path: ":slug/category/:category",
                component: RendererComponent,
            },
            {
                path: "page/:slug",
                component: RendererComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LandingPagesRoutingModule {}
